import { Input, SettingsCard, SettingsCardRow } from 'design-system';

type PersonalDetailsProps = {
  firstName: string | null;
  lastName: string | null;
  companyName: string | null;
  email: string | null;
};

const PersonalDetails = ({ firstName, lastName, companyName, email }: PersonalDetailsProps) => {
  const fields = [
    { id: 'settings-first-name', label: 'First Name', value: firstName ?? '' },
    { id: 'settings-last-name', label: 'Last Name', value: lastName ?? '' },
    { id: 'settings-company-name', label: 'Company Name', value: companyName ?? '' },
    {
      id: 'settings-email-address',
      label: 'Email Address',
      type: 'email',
      value: email ?? ''
    }
  ];

  return (
    <SettingsCard title='Personal Details'>
      {fields.map(field => (
        <SettingsCardRow
          key={field.id}
          label={field.label}
          labelFor={field.id}
        >
          <Input
            disabled
            id={field.id}
            type={field.type}
            value={field.value}
          />
        </SettingsCardRow>
      ))}
    </SettingsCard>
  );
};

export default PersonalDetails;
